import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { FormFieldIndicatorComponent } from './form-field-indicator.component';
import { FormFieldComponent } from './form-field.component';
import { LabelDirective } from './label.directive';

@NgModule({
  imports: [CommonModule, MatIconModule, ReactiveFormsModule],
  declarations: [
    FormFieldIndicatorComponent,
    FormFieldComponent,
    LabelDirective,
  ],
  exports: [FormFieldComponent, LabelDirective, FormFieldIndicatorComponent],
})
export class FormFieldModule {}
